import { get, post } from "./http";

export const accountLogin = async data => {
  return await post("/authorization", data);
};

// 展品、展商推荐
export const getRecommend = async data => {
  return await get("/recommend", data);
};

// 展品列表
export const getExhibits = async (data = { page: 0, size: 10 }) => {
  return await get("/exhibits", data);
};

// 展品详情
export const getExhibitDetail = async id => {
  return await get(`/exhibit/${id}`, {});
};

// 展馆列表
export const getVenues = async (data = { page: 0, size: 10 }) => {
  return await get("/venue", data);
};

// 根据展馆获取展商列表
export const getVenuesDetail = async id => {
  return await get(`/venue/${id}`, {});
};

//获取全部文章分类
export const getArticleCategory = async (data = {}) => {
  return await get(`/article-category`, data);
};

//获取文章分页
export const getArticles = async (
  data = { categoryId: null, page: 0, size: 5 }
) => {
  return await get(`/articles`, data);
};

//根据Id获取文章
export const getArticleDetail = async articleId => {
  return await get(`/articles/${articleId}`, {});
};

//按类型获取所有广告 EXHIBITOR,EXHIBIT,BANNER
export const getAds = async id => {
  return await get(`/advertisement`, {
    [`category.id`]: id,
    enabled: true,
    sort: "sequence,DESC"
  });
};

// 展商列表
export const getExhibitors = async (data = { page: 0, size: 10 }) => {
  return await get(`/exhibitors`, data);
};

// 获取全部展商
export const getAllExhibitors = async () => {
  return await get(`/exhibitor`, {});
};

// 展商详情
export const getExhibitorDetail = async exhibitorId => {
  return await get(`/web/exhibitor/${exhibitorId}`, {});
};

// 发送验证码
export const sendSMS = async number => {
  return await post(`/authorization/registration/sms/code/${number}`, {});
};

// 创建账户
export const createAccount = async data => {
  return await post(`/authorization/registration/account`, data);
};

// 填写用户信息进行账号绑定
export const bindAccount = async (accountId, data) => {
  return await post(
    `/authorization/registration/account/${accountId}/visitor`,
    data
  );
};

// 创建一条展品（展商）点赞记录
// {
//   "exhibit": {
//       "id": "502909137307439104"
//   },
//   "visitor": {
//       "id": "502893856535220224"
//   }
// }
export const likeRecord = async data => {
  return await post(`/liked-record`, data);
};

// 创建一条展品（展商）点赞记录
// {
//   "exhibit": {
//       "id": "502909137307439104"
//   },
//   "visitor": {
//       "id": "502893856535220224"
//   }
// }
export const collectRecord = async data => {
  return await post(`/collected-record`, data);
};

// 创建一条询盘 询盘目前应该只支持观众创建
// {
//   "exhibit": {
//       "id": "502909137307439104"
//   },
//   "quantity": 404,
//   "description": "本公司想订购404个这样的链条，不知道价格是否可以谈谈？",
//   "contactName": "张三",
//   "contactNumber": "17714363284",
//   "visitor": {
//       "id": "502893856535220224"
//   }
// }
export const enquiry = async data => {
  return await post(`/web/enquiry`, data);
};

export const reserve = async data => {
  return await post("/web/information", data);
};

// 发布供应SUPPLY
// 预约 APPOINTMENT 不确定的需求，是否支持展商预约展商
// 联系主办方 SPONSOR
// 预约 APPOINTMENT
export const publish = async data => {
  return await post(`/web/publish`, data);
};

// 发送邮件
export const sendEmail = async data => {
  return await post(`/web/email`, data);
};

//新版本接口调用从这里开始 20231004 hebang

// banner
export const getBanners = async () => {
  return await get(`/advertisement`, {
    [`category.id`]: 1,
    enabled: true,
    sort: "sequence,DESC"
  });
};

// 广告位展品列表
export const getExhibitAdvertisements = async () => {
  return await get(`/web/getExhibitAdvertisements`, {
    putLocationId: 2,
    linkType: "EXHIBIT"
  });
};

// 热门单品
// export const getHotExhibits3 = async (data = { page: 0, size: 10 }) => {
//   return await get("/web/getHotExhibits", data);
// };

// 行业资讯图片
export const getAdvertisements = async params => {
  return await get(`/web/getAdvertisement`, { ...params });
};

// 热门单品
// export const getHotExhibitPage = async (data = { page: 0, size: 10 }) => {
//   return await get("/web/exhibitPage", data);
// };

// 热门单品
export const getHotExhibits3 = async (data = { page: 0, size: 10 }) => {
  return await get("/web/getHotExhibits", data);
};

// 热门单品
export const getHotExhibitPage = async (data = { page: 0, size: 10 }) => {
  return await get("/web/exhibitPage", data);
};

// 热门单品
export const getHotExhibits = async (data = { page: 0, size: 10 }) => {
  return await get("/exhibits", data);
};

// banner 线上展厅
export const getOnlineShowBanners = async () => {
  return await get(`/advertisement`, { path: "/onlineshow" });
};

// banner 企业专区
export const getBusinessZoneBanners = async () => {
  return await get(`/advertisement`, { path: "/business" });
};

// banner 行业资讯
export const getArticleBanners = async () => {
  return await get(`/advertisement`, { path: "/article" });
};

// 展品一级分类
export const getExhibitCategory = async params => {
  return await get(`/exhibit-category`, { ...params });
};

// 场馆列表
export const getVenue = async () => {
  return await get(`/venue`, {});
};

// 展品列表
export const getExhibitPageList = async (entity, pageable) => {
  return await get(`/exhibitPage`, { ...entity, ...pageable });
};

// 展馆列表
export const getExhibitorPageList = async (entity, pageable) => {
  return await get(`/exhibitorPage`, { ...entity, ...pageable });
};

// 展商展品列表
export const getExhibitsPageList = async (entity, pageable) => {
  return await get(`/exhibitsPage`, { ...entity, ...pageable });
};

export const getDictData = async params => {
  return await get("/dictionaries", params);
};



// WEBPACK FOOTER //
// ./src/http/api.js